(() => {
  angular
    .module('app.report')
    .controller('SupportReportController', SupportReport);

  SupportReport.$inject = [
    '$q',
    '$scope',
    '$filter',
    '$interval',
    'Report',
    'CampaignService'
  ];

    function SupportReport(
      $q,
      $scope,
      $filter,
      $interval,
      Report,
      CampaignService
  ) {
    const { report } = $scope.$parent;
    const vm = this;

    activate();

    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      report.trackpointsPromise = report.trackpointsPromise ||
          CampaignService.getTrackpointsWithEventCount(report.campaignIdParam).$promise;

      vm.supportPromise = vm.supportPromise || Report.getSupportData(report.campaignIdParam).$promise;

      $q.all([
        report.campaignPromise,
        report.trackpointsPromise,
        vm.supportPromise
      ]).then((response) => {
        vm.campaign = response[0];
        const startDate = new Date(vm.campaign.c_start ? vm.campaign.c_start : undefined);
        const endDate = new Date(vm.campaign.c_end ? vm.campaign.c_end : undefined);
        vm.slider.init(startDate, endDate);

        vm.trackpointSelector.activeTps = _.filter(response[1].data, (trackpoint) => {
          return trackpoint.active === true;
        });

        vm.chartDataScope = null;
        vm.setChartDataScope('campaign');
      }).then(() => {
        report.isCampaignLoading = false;
        report.isCampaignLoaded = true;
      });
    }

    /* ------------------------------
     Top table and associated logic
     --------------------------------*/
    vm.top = {
      panelistCountries: undefined,
      lookupCountries: undefined,
      totalCount: undefined,
      referrers: undefined,
      ips: undefined,
      refreshData: function (dataSource) {
        if (angular.isUndefined(dataSource)) return;
        vm.top.panelistCountries = dataSource.panelistCountries;
        vm.top.lookupCountries = dataSource.lookupCountries;
        vm.top.totalCount = dataSource.totalCount;
        vm.top.referrers = dataSource.referrers;
        vm.top.ips = dataSource.ips;
      }
    };

    /* ------------------------------
     Trackpoint select dropdown and associated logic
     --------------------------------*/
    vm.setChartDataScope = function (chartDataScope) {
      if (vm.chartDataScope !== chartDataScope) {
        vm.supportLoaded = false;
        vm.chartDataScope = chartDataScope;

        let waitForSupport;
        let param = {id: vm.campaign.pid};

        if (vm.chartDataScope === 'campaign') {
          vm.trackpointDataScope = undefined;
          vm.supportPromise = vm.supportPromise || Report.getSupportData(param).$promise;

          waitForSupport = vm.supportPromise;
        } else {
          let currentTrackpoint = vm.trackpointSelector.activeTps[chartDataScope];
          param['trackpointId'] = `${currentTrackpoint.cid}:${currentTrackpoint.tailcode}`;
          waitForSupport = Report.getSupportData(param).$promise;
        }

        waitForSupport.then(response => {
          if (!response.data) {
            console.error(response);
            return false;
          }

          if (response.data.statusCode === 500) {
            console.error(response.data);
            return false;
          }

          vm.panelImpsToImpsRatio = response.data.panelEvents;
          vm.topPerformers = response.data.performers;
          if (vm.chartDataScope === 'campaign') {
            vm.top.refreshData(vm.topPerformers);
          } else {
            vm.setTrackpointDataScope('total');
          }
          vm.supportLoaded = true;
        });
      }
    };

    vm.setTrackpointDataScope = function (scope) {
      vm.trackpointDataScope = scope;

      if (vm.trackpointDataScope === 'total') {
        vm.top.refreshData(vm.topPerformers.totals);
      } else {
        let data = getDataForDate(vm.slider.getCurrentDate());
        vm.top.refreshData(data);
      }
    };

    function getDataForDate(date) {
      let data = {};
      if (vm.topPerformers.dates && vm.trackpointSelector.selectedTrackpoint.id >= 0) {
        angular.forEach(vm.topPerformers.dates, function (dateEntry) {
          if (dateEntry.date === $filter('date')(date, "yyyy-MM-dd")) {
            data = dateEntry;
          }
        });
      }
      return data;
    }

    vm.trackpointSelector = {
      activeTps: [],
      selectedTrackpoint: {
        id: -1,
        name: ''
      },
      selectTrackpoint: function (id, tp) {
        this.selectedTrackpoint.id = id;
        this.selectedTrackpoint.name = tp.name;
        vm.setChartDataScope(id);
      }
    };

    /* ------------------------------
     Date slider logic
     --------------------------------*/
    //TODO: would be better off in a directive ?
    vm.slider = {
      min: 0,
      currentValue: 0,
      startDate: undefined,
      endDate: undefined,
      disabled: true,
      datesArray: [],
      getCurrentDate: function () {
        return this.datesArray[this.currentValue];
      },
      dayCount: function () {
        const count = Math.floor((this.endDate.getTime() - this.startDate.getTime()) / (24 * 60 * 60 * 1000));
        if (count) {
          this.disabled = false;
          return count;
        } else {
          this.disabled = true;
          return 0;
        }
      },
      init: function (startDate, endDate) {
        this.startDate = startDate;
        this.endDate = endDate;
        let currentDate = this.startDate;
        let lastDate = new Date(this.endDate);
        lastDate.setDate(lastDate.getDate() + 1);
        while (currentDate <= lastDate) {
          this.datesArray.push(new Date(currentDate));
          const newDate = new Date(currentDate);
          currentDate = newDate.setDate(newDate.getDate() + 1);
        }
      }
    };

    /* ------------------------------
     Slider watches
     --------------------------------*/
    let sliderStepCounter = 0; // fast update of DataTables issue
    let sliderDelay = null;
    $scope.$watch(() => vm.slider.currentValue,
      (newValue, oldValue) => {
        if (sliderStepCounter++ > 10) {
          sliderStepCounter = 10;
        }

        if (newValue && (parseInt(newValue) !== parseInt(oldValue))) {
          if (!sliderDelay) {
            sliderDelay = $interval(() => {
              if (sliderStepCounter-- < 0) {
                $interval.cancel(sliderDelay);
                sliderStepCounter = 0;
                sliderDelay = null;

                const data = getDataForDate(vm.slider.getCurrentDate());
                vm.top.refreshData(data, new Date());
              }
            }, 100);
          }
        }
      },
      true);
  }
})();
